import React from 'react';
import styles from './styles.scss';
import ellipse from "../../../../assets/media/icons/Ellipse.png";

import exit from "../../../../assets/media/icons/exit_dark_grey.png";
import {connect} from "react-redux";
import {logoutRequest} from "../../../../fetch/auth";
import {Link} from "react-router-dom";


export class UserCardUI extends React.Component {

    render() {
        return <div className={styles.userSmallCard} style={this.props.style || {}}>
            <Link to={'/user/'.concat(this.props.user.login)} className={styles.userSmallCardName} style={{textDecoration: "none"}}>
                {this.props.user.nickname && this.props.user.nickname.length > 0 ? this.props.user.nickname :this.props.user.login}
            </Link>
            <img src={ellipse} alt="ellipse"
                 className={styles.newNotifications} style={this.props.user.isNewNotify ? {display: "flex"} :{display: "none"}}/>
            <Link to={'/user/'.concat(this.props.user.login)}>
            <img src={this.props.user.avatarAfterSave != null ? this.props.user.avatarAfterSave : this.props.user.avatar}
                 alt="avatar" className={styles.userSmallCardAvatar}/>
            </Link>
            <img src={exit} alt="exit" className={styles.userSmallCardExit}
                 onClick={this.props.logout}/>
        </div>
    }
}

export const UserCard = connect(
    store => ({
        isAuthorized: store.persistStore.isAuthorized,
        user: store.user,
    }),
    dispatch => ({
        logout() {
            logoutRequest(dispatch);
        }
    })
)(UserCardUI);



// WEBPACK FOOTER //
// src/components/forumFullPage/forumHeader/userCard/index.jsx